class Slider extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      start: 'slider-start',
      end: 'slider-end'
    };

    isIntersecting(this, this.#init.bind(this));
    this.#setListeners();
  }

  #init() {
    if (!window.Swiper) return;

    let thumbsInstance;
    const config = JSON.parse(this.dataset.config || '{}');

    if (config.thumbs && config.thumbs.selector) {
      thumbsInstance = this.#thumbs(config.thumbs.selector);

      if (thumbsInstance) config.thumbs.swiper = thumbsInstance;
    }

    const instance = new Swiper(this, config);

    if (instance.isBeginning) this.classList.add(this.classes.start);

    instance.on('slideChange', () => {
      this.classList[instance.isBeginning ? 'add' : 'remove'](this.classes.start);
      this.classList[instance.isEnd ? 'add' : 'remove'](this.classes.end);
    });
  }

  #thumbs(selector) {
    const thumbs = document.querySelector(selector);

    if (!thumbs) return false;

    const config = JSON.parse(thumbs.dataset.config || '{}');

    return new Swiper(thumbs, config);
  }

  #setListeners() {
    document.addEventListener('reinit-slider', event => this.#init(event.swiper));
  }
}

customElements.define('aw-slider', Slider);
